module.exports = __webpack_public_path__ + "static/media/D3_C5_001.1b194739.png";